import { Component, inject, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { ThemeService } from '../../../../src/app/core/services/theme.service';

@Component({
    selector: 'alta-footer',
    standalone: true,
    imports: [CommonModule, RouterLink],
    templateUrl: './alta.footer.componente.html',
    styleUrls: ['./alta.footer.componente.scss']
})
export class SdsFooterComponent {
    private themeService = inject(ThemeService);
    currentYear = new Date().getFullYear();

    logoSrc = computed(() => {
        const theme = this.themeService.theme;
        return theme === 'dark'
            ? '/assets/brand/ALTA_SISTEMAS/SVG/logo-white.svg'
            : '/assets/brand/ALTA_SISTEMAS/SVG/logo-black.svg';
    });

    scrollToSection(event: Event, sectionId: string): void {
        event.preventDefault();
        const element = document.getElementById(sectionId);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else {
            // Se não encontrar a seção, navega para home com fragmento
            window.location.href = '/#' + sectionId;
        }
    }
}

